import React, { FC } from 'react';

import { State } from './interface';
import { text } from './text';
import { assertNever } from './util';

export const PhaseAside: FC<{ phase: State['phase'] }> = ({ phase }) => {
    switch (phase) {
        case 'loading':
        case 'submitting':
        case 'input':
            return (
                <aside>
                    <h1>{text.title[phase]}</h1>
                    <p>{text.loading[0]}</p>
                    <p>
                        {text.loading[1]}{' '}
                        <a href={`mailto:${text.helpEmail}`}>
                            {text.helpEmail}
                        </a>.
                    </p>
                </aside>
            );
        case 'done':
            return (
                <aside>
                    <div className="c-narrow">
                        <h1>{text.title.done}</h1>
                        <p>{text.thanks[0]}</p>
                        <p>
                            {text.thanks[1]}{' '}
                            <a href={`mailto:${text.helpEmail}`}>
                                {text.helpEmail}
                            </a>.
                        </p>
                    </div>
                </aside>
            );
        default:
            return assertNever(phase);
    }
};
